var $ = require('jquery');

module.exports = function() {

if ($('body').hasClass('search')) {

  var Mustache = require('mustache');
  var firstSubmit = true;
  var value = "";
  var response = {};
  var searchContent = $('#js-search-content');
  var loadingContent = $('#js-loading-content');
  var template = $("#search-results-template").html();
  var searchQuery = $("#js-search-query");
  var searchQueryReserve = $("#js-reserve-query");

  $(document).on('submit', '#searchform', function(e) {
    if ($(this).parent().hasClass('hero__search')) {
      e.preventDefault();
      searchAjax();
      return false;
    }
  });

  function searchAjax() {

    if (firstSubmit) {
      value = $(searchQueryReserve).val();
    }else{
      value = $('.hero__search').find('#js-searchform-text').val();
    }

    ajaxLoading(value);

    $.ajax({
      type : 'POST',
      url : ajaxurl,
      data : {
        action : 'get_filtered_search',
        query : value
      },

      success: function(response) {
        console.log(response);
        updateDom(response);
      },
      error: function(errorThrown){
        console.log('ajax error ' + JSON.stringify(errorThrown));
      }
    });
  }

  function updateDom(response) {
    //$(searchQuery).text('Sökresultat för: ' + value);
    $('.js-search-hits').html('Antal träffar: ' + (response.count ? response.count : 0));
    var rendered = Mustache.render(template, response);
    $(searchContent).html(rendered);
    $(loadingContent).removeClass('-fade');
    $(searchContent).show();
    firstSubmit = false;
  }

  function ajaxLoading(value) {
    $(searchContent).hide();
    $(loadingContent).addClass('-fade');
    $(searchQuery).text('Sökresultat för: ' + value);
    $('.js-search-hits').text('Antal träffar: ' + '...');
  }

  searchAjax();

}

}();



// WEBPACK FOOTER //
// ./components/filter_search.js